import { Header } from "common/App/Header";
import { PageWrapper } from "common/App/PageWrapper";

export const PageRenderer = ({ element }) => {
  return (
    <>
      <Header />
      <div className=" md:ml-[280px] mt-20 p-6">
        <PageWrapper>{element}</PageWrapper>
      </div>
    </>
  );
};
